import * as React from 'react';
import * as styles from './PhoneButtonStickyLayout.css';

export const PhoneButtonStickyLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
